import type { AxiosError, AxiosInstance } from "axios";

export function duplicateContentTypeBuilder(apiClient: AxiosInstance) {
  return async function duplicateContentType(uuid: string): Promise<any> {
    try {
      const response = await apiClient.post(`/v2/pages/${uuid}/duplicate/`);
      return response.data;
    } catch (error: unknown) {
      if (
        (error as AxiosError).response?.status === 404 ||
        (error as AxiosError).response?.status === 400
      ) {
        return null;
      } else {
        throw error;
      }
    }
  };
}
